// extracted by mini-css-extract-plugin
export var changeIcon = "_4e-4";
export var container = "_4e-0";
export var divider = "_4e-7";
export var externalLinkIcon = "_4e-1";
export var green = "_4e-5";
export var helpCircleIcon = "_4e-3";
export var iconButton = "_4e-2";
export var red = "_4e-6";